import type { RootState } from 'src/app/store/types';

export function selectCurrentTripSummaryId(state: RootState) {
  return state.tripSummary.currentTripSummaryId;
}
